export default [
  {
    header: `Version ${process.env.VUE_APP_VERSION}`,
  },
]
